import { nullable } from '@abb-procure/api';
import * as t from 'io-ts';
import { EntityStatusDto } from './enitity-status-dto.type';
import { SearchHierarchyElementDto } from './search-hierarchy-element-dto.type';

const SearchBaseDto = t.type(
  {
    id: t.string,
    entityType: nullable(t.string),
    entityNumber: nullable(t.string),
    name: nullable(t.string),
    status: nullable(EntityStatusDto),
    updated: nullable(t.string),
    lastVisited: nullable(t.string),
    hierarchy: nullable(t.array(SearchHierarchyElementDto)),
  },
  'SearchBaseDto',
);

type SearchBaseDto = t.TypeOf<typeof SearchBaseDto>;
export { SearchBaseDto };
